import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface DemoContextType {
  isDemoMode: boolean;
  currentStep: number;
  startDemo: () => void;
  endDemo: () => void;
  nextStep: () => void;
  previousStep: () => void;
}

const DemoContext = createContext<DemoContextType | undefined>(undefined);

export function DemoProvider({ children }: { children: React.ReactNode }) {
  const [isDemoMode, setIsDemoMode] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const navigate = useNavigate();

  const startDemo = () => {
    setIsDemoMode(true);
    setCurrentStep(0);
    navigate('/demo/welcome');
  };

  const endDemo = () => {
    setIsDemoMode(false);
    setCurrentStep(0);
    navigate('/');
  };

  const nextStep = () => {
    setCurrentStep(prev => prev + 1);
  };

  const previousStep = () => {
    setCurrentStep(prev => Math.max(0, prev - 1));
  };

  return (
    <DemoContext.Provider value={{
      isDemoMode,
      currentStep,
      startDemo,
      endDemo,
      nextStep,
      previousStep
    }}>
      {children}
    </DemoContext.Provider>
  );
}

export function useDemoMode() {
  const context = useContext(DemoContext);
  if (context === undefined) {
    throw new Error('useDemoMode must be used within a DemoProvider');
  }
  return context;
}